import { snakeToCamel } from '../../../utils/object'

import Model from '../models'

import EvaluationQuestionAPI from './api'

export default class EvaluationQuestion extends Model {
  static api = EvaluationQuestionAPI.create(EvaluationQuestion)

  constructor({
    id = null,
    questionType = '',
    questionText = null,
    helpText = '',
    choices = [],
    section = null,
  } = {}) {
    super()
    Object.assign(this, {
      id,
      questionType,
      questionText,
      helpText,
      section,
      choices,
    })
  }

  static create(opts = {}) {
    return new EvaluationQuestion(opts)
  }

  static fromAPI(json = {}) {
    const camelJson = snakeToCamel(json)
    return new EvaluationQuestion(camelJson)
  }

  copy() {
    return new EvaluationQuestion(this)
  }
}
